import { JiraPriorityAri } from '@atlassian/ari/jira/priority';
import type { jiraPriorityFieldFragment as PriorityField } from '@atlassian/jira-business-fields/src/common/field-types/priority/fragment/__generated_apollo__/jiraPriorityFieldFragment.ts';
import { PRIORITY_TYPE } from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import type { PriorityFormData } from './types';

export const transformPriorityFieldForOptimisticUpdates: DataTransformFn<
	PriorityField,
	PriorityFormData
> = (existingField: PriorityField, fieldData: PriorityFormData): PriorityField => {
	const priorityId =
		fieldData.value && JiraPriorityAri.check(fieldData.value)
			? JiraPriorityAri.parse(fieldData.value).resourceId
			: fieldData?.value ?? '';
	return {
		...existingField,
		priority: {
			id: fieldData.value ?? '',
			name: fieldData.label,
			priorityId,
			iconUrl: fieldData.iconUrl,
			__typename: 'JiraPriority',
		},
	};
};

export const priorityOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<PriorityField, PriorityFormData>;
} = {
	[PRIORITY_TYPE]: transformPriorityFieldForOptimisticUpdates,
};
